import * as React from "react";

// importing material UI components
import { useState, useEffect } from "react";
import AppointmentManagementTable from "./AppointmentManagementTable";
import {
  Grid,
  TextField,
  Typography,
  Container,
  ToggleButtonGroup,
  ToggleButton,
  Tooltip,
  Stack,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import Search from "@mui/icons-material/Search";
import ListIcon from "@mui/icons-material/List";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import GoogleSync from "./GoogleSync";
import CalendarView from "./CalendarView";
import typography from "../../cssUtils/typography";
import CustomTabs from "../../common/custom-tabs";

const AppointmentManagement = (props) => {
  const [viewType, setViewType] = useState("list");
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");
  const [charCount, setCharCount] = useState(0);

  // Debounce Search Query
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  const handleSearchQueryChange = (event) => {
    const value = event.target.value;

    if (value.length > 50) {
      return;
    }

    setSearchQuery(value);
    setCharCount(value.length);
  };

  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setViewType(newView);
    }
  };

  return (
    <div className="App" >
      <Container maxWidth={false} sx={{ p: 3}}>
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 2 }}
        >
          <Grid item>
            <Typography sx={{ ...typography.h1 }}>
              Appointment Management System
            </Typography>
          </Grid>
          <Grid item>
            <CustomTabs
              value={viewType}
              onChange={(event, newValue) => handleViewChange(event, newValue)}
              tabs={[
                { label: "List View",     value: "list"     },
                { label: "Calendar View", value: "calendar" },
              ]}
            />
          </Grid>
        </Grid>

        {/* Search Field */}

        {viewType === "list" && (
          <Stack
            direction="row"
            sx={{
              mb: 2,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Tooltip
              title="Search by name, phone, or agent"
              arrow
              placement="top"
            >
              <TextField
                sx={{ width: 250 }}
                size="small"
                placeholder="Search"
                value={searchQuery}
                onChange={handleSearchQueryChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <Typography variant="caption">{charCount}/50</Typography>
                    </InputAdornment>
                  ),
                }}
              />
            </Tooltip>

            <GoogleSync />
          </Stack>
        )}

        {viewType === "list" ? (
          <AppointmentManagementTable
            refreshkey={props.refreshKey}
            searchQuery={debouncedSearchQuery}
          />
        ) : (
          <CalendarView refreshKey={props.refreshKey} />
        )}
      </Container>
    </div>
  );
};

export default AppointmentManagement;
